import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog';
import EntityPicker from 'components/Pickers/Picker';
import { dialog } from 'src/boot/mixins.js';
import { forEach, map, merge, orderBy } from 'lodash';
export default {
  mixins: [dialog],
  props: ['phaseName', 'onClose'],
  components: {
    EntityPicker: EntityPicker,
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      changes: {},
      phases: [],
      firstLoad: false,
      loading: true,
      isDirty: false,
      pagination: {
        sortBy: 'project_lower_name',
        descending: false,
        page: 1,
        rowsPerPage: 25,
        rowsNumber: 10
      },
      columns: [{
        name: 'project.name',
        field: 'project_name',
        label: this.$tc('general.project', 1),
        align: 'left',
        sortable: false,
        classes: 'bg-grey-2',
        style: 'width: 200px',
        headerClasses: 'bg-secondary text-white',
        headerStyle: 'text-weight: bold; width: 200px'
      }, {
        name: 'is_active',
        field: 'is_active',
        label: this.$t('general.active'),
        align: 'left',
        style: 'width: 50px',
        sortable: false,
        headerStyle: 'text-weight: bold; width: 50px'
      }, {
        name: 'name',
        field: 'name',
        label: this.$tc('general.name', 1),
        style: 'width: 220px',
        align: 'left',
        sortable: false,
        headerStyle: 'text-weight: bold; width: 220px'
      }, {
        name: 'task_category_id',
        field: 'task_category',
        label: this.$tc('general.category', 1),
        style: 'width: 190px',
        align: 'left',
        sortable: false,
        headerStyle: 'text-weight: bold; width: 190px'
      }, {
        name: 'minutes_total',
        field: 'minutes_total',
        label: this.$t('general.time_tracked'),
        style: 'width: 100px',
        align: 'right',
        sortable: false,
        headerStyle: 'text-weight: bold; width: 100px'
      }]
    };
  },
  computed: {
    phasesCopy: function phasesCopy() {
      return this.phases;
    }
  },
  watch: {
    phases: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && this.firstLoad) {
          this.isDirty = true;
        }

        if (!this.firstLoad) {
          this.firstLoad = true;
        }
      }
    }
  },
  methods: {
    setChange: function setChange(row) {
      if (row) {
        this.changes[row.task_id] = row;
      }
    },
    updateNames: function updateNames() {
      var _this = this;

      var name = this.phases[0].name;
      forEach(this.phases, function (phase, index, collection) {
        _this.setChange(phase);

        collection[index].name = name;
      });
    },
    updateCategories: function updateCategories() {
      var _this2 = this;

      var categoryId = this.phases[0].task_category_id;
      forEach(this.phases, function (phase, index, collection) {
        _this2.setChange(phase);

        collection[index].task_category_id = categoryId;
      });
    },
    onRowClick: function onRowClick(row) {
      window.open('/projects/' + row.project.project_id);
    },
    onTimeClick: function onTimeClick(row) {
      this.openDialog('EntriesDialog', {
        filters: {
          project_ids: [row.project_id],
          phase_ids: [row.task_id]
        }
      });
    },
    save: function save() {
      var _this3 = this;

      this.loading = true;
      this.$axios.post('/phases/update', {
        phases: map(this.changes, function (phase) {
          var data = {
            task_id: phase.task_id,
            name: phase.name,
            is_open: phase.is_open
          };

          if (phase.task_category_id > 0) {
            data.task_category_id = phase.task_category_id;
          } else {
            data.task_category_id = null;
          }

          return data;
        })
      }).then(function (response) {
        _this3.loading = false;

        _this3.$q.notify({
          message: _this3.$t('general.phases_updated'),
          type: 'positive'
        });

        _this3.hide();
      }).catch(function (response) {
        _this3.loading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchParams = {};
      this.pagination = {
        sortBy: 'project_lower_name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 10
      };
      this.search();
    },
    search: function search() {
      this.$refs.phaseTable.requestServerInteraction();
    },
    loadData: function loadData(props) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _props$pagination, page, rowsPerPage, sortBy, descending;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props$pagination = props.pagination, page = _props$pagination.page, rowsPerPage = _props$pagination.rowsPerPage, sortBy = _props$pagination.sortBy, descending = _props$pagination.descending;
                _this4.pagination = props.pagination;
                _this4.loading = true;

                _this4.$axios.get('/phases', {
                  params: {
                    name: _this4.phaseName,
                    page: page,
                    per_page: rowsPerPage === 0 ? 10000 : rowsPerPage,
                    sort_by: sortBy,
                    direction: descending ? 'desc' : 'asc'
                  }
                }).then(function (response) {
                  _this4.phases = orderBy(map(response.data.data, function (phase) {
                    return _this4.changes[phase.task_id] ? merge(phase, _this4.changes[phase.task_id]) : phase;
                  }), [sortBy], [descending ? 'desc' : 'asc']);
                  _this4.pagination.rowsNumber = response.data.total;
                  _this4.pagination.page = response.data.current_page;
                  _this4.pagination.sortBy = sortBy;
                  _this4.pagination.descending = descending;
                  _this4.pagination.rowsPerPage = rowsPerPage;

                  _this4.$q.loading.hide();

                  _this4.loading = false;
                }).catch(function (response) {
                  _this4.loading = false;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadData({
      pagination: this.pagination,
      filter: null
    });
  }
};